import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="w-full bg-[#0A0A0A] py-16 px-4 border-t border-[#16161F]" data-id="element-262">
      <div className="max-w-2xl mx-auto" data-id="element-263">
        <div className="bg-[#16161F] border border-[#FF6B00] rounded-3xl p-8 sm:p-10 text-center shadow-2xl relative overflow-hidden" data-id="element-264">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#FF6B00] to-[#FFD700]" data-id="element-265" />

          <p className="text-[#FF6B00] text-xs sm:text-sm font-black uppercase tracking-widest mb-4" data-id="element-266">
            ⏰ Limited-time offer
          </p>

          <h2 className="text-2xl sm:text-4xl font-black text-white mb-8 tracking-tight" data-id="element-267">
            The launch price ends in:
          </h2>

          <div className="mb-8" data-id="element-268">
            <CountdownTimer size="lg" blinking={true} data-id="element-269" />
          </div>

          <p className="text-white text-base sm:text-lg font-bold mb-8" data-id="element-270">
            After that, the price goes up by{' '}
            <span className="text-[#FF6B00]" data-id="element-271">$5</span> and never comes back
            down.
          </p>

          <div className="max-w-sm mx-auto" data-id="element-272">
            <div className="w-full bg-[#0A0A0A] rounded-full h-4 overflow-hidden border border-[#FF6B0033] mb-3" data-id="element-273">
              <div className="h-full rounded-full bg-gradient-to-r from-[#FF6B00] to-[#FFD700]" style={{
              width: '72%'
            }} data-id="element-274" />
            </div>
            <div className="flex items-center justify-between px-1" data-id="element-275">
              <span className="text-[#FF6B00] font-black text-xs uppercase tracking-wider" data-id="element-276">
                🔴 Limited spots
              </span>
              <span className="text-[#B0B0C0] font-bold text-xs uppercase tracking-wider" data-id="element-277">
                72% claimed
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}